export enum ComissaoStatusEnum {
    PENDENTE = 1,
    PAGO = 2,
    CANCELADO = 3
  }

export const ComissaoStatusLabels: { [key: number]: string } = {
    [ComissaoStatusEnum.PENDENTE]: 'Pendente',
    [ComissaoStatusEnum.PAGO]: 'Pago',
    [ComissaoStatusEnum.CANCELADO]: 'Cancelado'
};

export const ComissaoStatusColors: { [key: number]: string } = {
    [ComissaoStatusEnum.PENDENTE]: 'bg-yellow-500/20 text-yellow-500',
    [ComissaoStatusEnum.PAGO]: 'bg-green-500/20 text-green-500',
    [ComissaoStatusEnum.CANCELADO]: 'bg-red-500/20 text-red-500'
};
  